import { render, staticRenderFns } from "./BookEditForm.vue?vue&type=template&id=922291a6&"
import script from "./BookEditForm.vue?vue&type=script&lang=js&"
export * from "./BookEditForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports